import { IDateTimeFormater } from './dateFormater';
import * as moment from 'moment';

export function createDateFormaterSvc(): IDateTimeFormater {
    return {
        isValid: date => {
            return !isNaN(date.getTime());
        },
        toDate: (date: string | null) => {
            if (date) {
                return moment(date).toDate();
            }
            return null;
        },
        toString: (date: Date) => {
            return (
                '/Date(' +
                date.getTime() +
                moment(date)
                    .format('Z')
                    .replace(':', '') +
                ')/'
            );
        }
    };
}
